<template>
  <footer class="bbm-footer">
    <div class="bbm-footer__inner">
      <div class="bbm-footer__brand">
        <img src="/images/static-home-page/brussels/brussels-innovation-ecosystem-no-background.png" class="bbm-footer__logo-img" alt="Brussels Innovation Ecosystem"/>
        <p class="bbm-footer__tagline">© 2026 We Connect Data <br> Empowering the heart of Europe's innovation.</p>
      </div>
      <div class="bbm-footer__links">
        <a class="bbm-footer__link" href="https://datascouts.eu/privacypolicy" target="_blank">Privacy Policy</a>
        <a class="bbm-footer__link" href="https://datascouts.eu/termsandconditions/" target="_blank">Terms and Conditions</a>
        <a class="bbm-footer__link" href="https://datascouts.eu/about" target="_blank">Contact</a>
        <!--        <a class="bbm-footer__link" href="">Data Sources</a>
                <a class="bbm-footer__link" href="#">Partner with Us</a>-->
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'SimplifiedFooterBrussels',
  })
</script>

<style scoped lang="scss">
  $bbm-accent: #ff6f31;

  .bbm-footer {
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    font-family: 'Space Grotesk', 'Inter', sans-serif;
  }

  .bbm-footer__inner {
    max-width: 1280px;
    margin: 0 auto;
    padding: 48px 32px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
  }

  .bbm-footer__brand {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .bbm-footer__logo-img {
    width: 200px;
    display: block;
  }

  .bbm-footer__tagline {
    font-size: 0.85rem;
    color: #64748b;
    max-width: 380px;
    margin: 0;
  }

  .bbm-footer__links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
  }

  .bbm-footer__link {
    font-size: 0.85rem;
    color: #64748b;
    text-decoration: none;
    font-family: 'Space Grotesk', sans-serif;
    transition: color 0.15s;

    &:hover {
      color: $bbm-accent;
    }
  }

  @media (max-width: 768px) {
    .bbm-footer__inner {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .bbm-footer__tagline {
      max-width: 100%;
    }
  }
</style>
